import { createContext, useContext } from 'react';
// @ts-ignore
import * as config from './index.js';

type ConfigType = {
  LOCALES: string[];
  DEFAULT_FRONT_PAGE_SLUG: string;
  DEFAULT_LOCALE: string;
  POSTS_COUNT: number;
  PHONES: {
    SUPPORT: string;
    HELP: string;
  };
  EMAILS: {
    HELP: string;
    MARKETING: string;
  };
  FORMAT: {
    DATE: string;
    TIME: string;
  };
  MEDIAQUERY: {
    MOBILE: number;
    LAPTOP: number;
    DESKTOP: number;
  };
  CONTENT: {
    VIDEO: {
      PATIENT: string;
      DOCTOR: string;
      COMPANY: string;
      EHEALTH: string;
    };
  };
  SOCIAL: {
    FACEBOOK: string;
    INSTAGRAM: string;
    LINKEDIN: string;
    YOUTUBE: string;
    VIBER: string;
  };
};

export const ConfigContext = createContext<ConfigType>({
  ...config,
});

export function useConfig(): ConfigType {
  return useContext(ConfigContext);
}
